export var COLLAPSE_ELEM_BEFORE = Symbol('collapse-elem-before');